// extracted by mini-css-extract-plugin
export default {"container":"alhWyqydXOOlLhtHqFIg","box":"Y7CKRPyCWye6VsYHprtQ","date":"FilVxyrWWz8iugzirVes","title":"_aSGEn8N4Ilr1otBVQek"};